/* unplugin-vue-components disabled */import { ElPagination as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/pagination/style/css';
import { ElTooltip as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/tooltip/style/css';
import __unplugin_components_1 from 'D:/hjj/bio_link_pc/src/components/tabs.vue';
import { ElPopconfirm as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/popconfirm/style/css';
import _objectSpread from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "notify_box"
};
var _hoisted_2 = {
  class: "header_title"
};
var _hoisted_3 = {
  key: 1,
  class: "notify_body"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "notify_item_left"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "notify_item_left_html"
};
var _hoisted_8 = {
  class: "item_type"
};
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = {
  class: "notify_item_right"
};
var _hoisted_13 = {
  class: "tip"
};
var _hoisted_14 = {
  key: 2,
  class: "pagination_"
};
import { useUserStore } from "@/store/user";
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { get_user_msg_notify_list, user_msg_read, get_approval_flow_list, readAllMessage } from "@/api/apis";
import { replaceImgWithText } from "@/util/index";
import { ElMessage } from "element-plus";
export default {
  __name: 'blknews',
  setup(__props) {
    var router = useRouter();
    var userStore = useUserStore();
    var notify_header = ref([]);
    var tag_current_status = ref(1);
    var fy = reactive({
      page: 1,
      limit: 20
    });
    var total_count = ref(0);
    var icon = ref("");
    var notify_title = ref("");
    var notify_list = ref([]);
    var getlist = () => {
      get_user_msg_notify_list(_objectSpread(_objectSpread({}, fy), {}, {
        type: tag_current_status.value
      })).then(res => {
        if (res.code == 200) {
          icon.value = res.data[0].icon;
          notify_title.value = res.data[0].title;
          notify_list.value = res.data[0].list.map(x => {
            x.content_str = replaceImgWithText(x.content);
            return x;
          });
          total_count.value = res.data[0].total;
        }
      });
    };
    var handleConfirmAllRead = () => {
      readAllMessage({}, "PUT").then(res => {
        if (res.code == 200) {
          getlist();
          getnotify_header_menus();
          ElMessage.success("操作成功");
        }
      });
    };

    //获取消息中心menus
    var getnotify_header_menus = () => {
      get_user_msg_notify_list().then(res => {
        if (res.code == 200) {
          console.log("获取请求结果->", res);
          notify_header.value = res.data || [];
          notify_header.value.forEach(x => {
            x.count = x.unread_sum;
          });
        }
      });
    };
    getnotify_header_menus();
    var flowObj = ref({});
    var approvalFlowlist = ref([]);
    var getApprovalFlowList = () => {
      get_approval_flow_list({}).then(res => {
        if (res.code == 200) {
          approvalFlowlist.value = res.data.list;
          flowObj.value = (approvalFlowlist.value || []).reduce((acc, item) => {
            acc[item.type] = item.id;
            return acc;
          }, {});
        }
      });
    };
    getApprovalFlowList();
    var handle_look_detail = item => {
      user_msg_read({
        id: item.id
      }).then(res => {
        if (res.code == 200) {
          item.is_read = 2;
        }
      });
      if (item.type == 4) {
        // 去客户拜访提醒
        router.push("/work_bench/visit_detail/" + item.origin_id);
      } else if (item.type == 8) {
        router.push("/work_bench/visit_detail/" + item.origin_id + "?type=outvisit");
      } else if (item.type == 1) {
        // 系统消息
        switch (item.origin_type) {
          case 1:
            // 线索
            router.push("/work_bench/clue_detail/" + item.origin_id);
            break;
          case 2:
            // 客户拜访
            if (item.jump_type == 2) {
              router.push({
                path: "/work_bench/visit_detail/" + item.origin_id,
                query: {
                  content: encodeURIComponent(item.content)
                }
              });
            } else {
              router.push("/work_bench/visit_detail/" + item.origin_id);
            }
            break;
          case 3:
            break;
          case 4:
            router.push("/news?type=2");
            break;
          case 5:
            router.push("/work_bench/link?id=" + item.origin_id);
            break;
          case 6:
            router.push("/work_bench/visit_detail/" + item.origin_id + "?type=outvisit");
            break;
          case 7:
            router.push("/pms/task-detail/index?project_id=".concat(item.project_id, "&id=").concat(item.origin_id));
            break;
          case 8:
            router.push("/tripadd?id=".concat(item.origin_id));
            break;
          case 10:
            router.push("/order/detail?id=" + item.origin_id);
            break;
          default:
            userStore.notice_detail_item = item;
            router.push("/notify");
            break;
        }
      } else if (item.type == 2) {
        // 审核提醒
        console.log("origin_type", item.origin_type);
        switch (item.origin_type) {
          case 0:
            router.push({
              path: "/work_bench/sample_detail/" + item.origin_id,
              query: {
                is_look: true
              }
            });
            break;
          case 1:
            router.push({
              path: "/work_bench/quotation_detail/" + item.origin_id,
              query: {
                auth: "view"
              }
            });
            break;
          case 3:
            router.push("/work_bench/contract_detail?id=".concat(item.origin_id));
            break;
          case 4:
            router.push({
              path: "/quality_assurance/complaint/detail",
              query: {
                id: item.origin_id
              }
            });
            break;
          case 5:
            router.push({
              path: "/pms/project-record/detail",
              query: {
                id: item.origin_id,
                type: 2,
                project_id: item.origin_id,
                approval_flow_id: flowObj.value[4]
              }
            });
            break;
          case 6:
            router.push({
              path: "/pms/project-approval-detail/index",
              query: {
                id: item.origin_id,
                approval_flow_id: flowObj.value[3]
              }
            });
            break;
          case 7:
            router.push({
              path: "/pms/purchasel-detail/index",
              query: {
                id: item.origin_id,
                approval_flow_id: flowObj.value[5]
              }
            });
            break;
          case 8:
            router.push({
              path: "/purchase_flow/detail",
              query: {
                id: item.origin_id,
                approval_flow_id: flowObj.value[8]
              }
            });
            break;
          case 11:
            router.push("/pms/project-detail/index?id=" + item.origin_id + "&type=1");
            break;
          case 12:
            router.push("/work_bench/reimbursement_detail?id=" + item.origin_id);
            break;
          case 14:
            router.push("/work_bench/entertainment_detail?id=" + item.origin_id);
            break;
          case 13:
            router.push("/tripadd?id=" + item.origin_id);
            break;
          case 15:
            router.push("/pms/workhour-declare");
            break;
          case 16:
            router.push("/pms/project-detail/index?id=" + item.origin_id + "&type=1");
            break;
          case 19:
            router.push("/budget-detail?id=" + item.origin_id);
            break;
          default:
            userStore.notice_detail_item = item;
            router.push("/notify");
            break;
        }
      } else {
        userStore.notice_detail_item = item;
        router.push("/notify");
      }
    };
    var handleCurrentChange = () => {
      getlist();
    };

    /**
     * 更新数据
     */
    watch(() => {
      return tag_current_status.value;
    }, () => {
      getlist();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _component_el_popconfirm = __unplugin_components_0;
      var _component_tabs = __unplugin_components_1;
      var _component_el_tooltip = __unplugin_components_2;
      var _component_el_pagination = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("span", null, "消息中心", -1)), _cache[4] || (_cache[4] = _createTextVNode("   ")), _createVNode(_component_el_popconfirm, {
        onConfirm: handleConfirmAllRead,
        width: "200px",
        class: "box-item",
        title: "是否确认一键已读",
        placement: "bottom"
      }, {
        reference: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("span", {
          class: "iconfont icon-yijianyidu"
        }, null, -1)])),
        _: 1
      })]), notify_header.value && notify_header.value[0] ? (_openBlock(), _createBlock(_component_tabs, {
        key: 0,
        list: notify_header.value,
        defaultChild: {
          label: 'title',
          value: 'type'
        },
        name: "blknews",
        modelValue: tag_current_status.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tag_current_status.value = $event)
      }, null, 8, ["list", "modelValue"])) : _createCommentVNode("", true), notify_header.value && notify_header.value[0] ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notify_list.value, (item, i) => {
        return _openBlock(), _createElementBlock("li", {
          key: i,
          onClick: $event => handle_look_detail(item)
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          class: "imgback",
          src: icon.value,
          alt: ""
        }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, _toDisplayString(item.title || notify_title.value), 1), tag_current_status.value == 2 && item.content_str.length > 100 ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          placement: "top"
        }, {
          content: _withCtx(() => [_createElementVNode("div", {
            innerHTML: item.content_str
          }, null, 8, _hoisted_9)]),
          default: _withCtx(() => [_createElementVNode("div", {
            class: "txt",
            innerHTML: item.content_str
          }, null, 8, _hoisted_10)]),
          _: 2
        }, 1024)) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "txt",
          innerHTML: item.content_str
        }, null, 8, _hoisted_11))])]), _createElementVNode("div", _hoisted_12, _toDisplayString(item === null || item === void 0 ? void 0 : item.created_at), 1), _withDirectives(_createElementVNode("span", _hoisted_13, null, 512), [[_vShow, item.is_read == 1]])], 8, _hoisted_4);
      }), 128))])) : _createCommentVNode("", true), notify_header.value && notify_header.value[0] ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_el_pagination, {
        "current-page": fy.page,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => fy.page = $event),
        small: "",
        background: "",
        layout: "total,prev, pager, next",
        "page-size": fy.limit,
        total: total_count.value,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true)]);
    };
  }
};